import React, { useMemo } from 'react'
import { OrbitIndicator, OrbitIndicatorsContainer } from '../../../../../CommonComponents/timeline/Timeline'
import useAssets from '../../../hooks/useAssets'
import useSelectedGroupSatellite from '../../../hooks/useSelectedGroupSatellite'
import { getOrbitalInsightDetails } from '../../../../../CommonComponents/orbital-insights/helperFunction'

const OrbitIndicators = () => {
    const { orbitalInsights, orbitStartOption } = useAssets()
    const { selectedGroupSatellite } = useSelectedGroupSatellite()

    const selectedSatellite = useMemo(() => selectedGroupSatellite?.satelliteId, [selectedGroupSatellite?.satelliteId])
    const selectedOrbitalInsights = useMemo(() => (selectedSatellite && orbitalInsights?.data) ? orbitalInsights?.data[selectedSatellite] : null, [orbitalInsights.data, selectedSatellite])
    const Orbits = useMemo(() => getOrbitalInsightDetails(selectedOrbitalInsights, orbitStartOption), [selectedOrbitalInsights, orbitStartOption])

    return (
        <OrbitIndicatorsContainer>
            {Orbits.map((orbit) => {
                return (
                    <OrbitIndicator
                        key={orbit.orbitNumber}
                        className='orbit__point'
                        orbitName={`Orbit ${orbit.orbitNumber}`}
                        orbitStartTime={orbit.orbitStartTime}
                        orbitEndTime={orbit.orbitEndTime}
                        orbitDuration={orbit.orbitDuration}
                        uniqueId={`orbit_${orbit.orbitNumber}`}
                    />
                )
            })}
        </OrbitIndicatorsContainer>
    )
}

export default OrbitIndicators